import {
  MembershipLevel,
  CurrentPayPlan,
  RoleType,
  PriceCartItem,
  MembershipProductType,
  PaymentInTransactionDetail,
  MSSProspectiveCosts,
} from '@ace-clublabs/common-membership-api-types';
import {
  GenderCode,
  IGetConfirmationResponse,
  ICalculateCostResponse,
  IPaymentInfo,
  MSSBenefitLevel,
  MSSEnrollment,
  MSSMembers,
  MSSNotification,
  MSSProduct,
  MSSProductStatus,
  AdditionalDiscountType,
  IGreenBoxMessage,
  IAdditionalBenefits
} from '@lib/types';

export const GENDER_CODE = {
  M: 'Male',
  F: 'Female',
  X: 'Nonbinary',
};

export interface IMemberDetails {
  sessionId?: string | undefined;
  clubCode: string | undefined;
  loggedInCustomerId: string | undefined;
  clubRegion: string | undefined;
  termEffectiveDate: string | undefined;
  termExpirationDate: string | undefined;
  priorTermExpirationDate: string | undefined;
  joinYear: string | undefined | null;
  inRenewal: boolean | undefined;
  inArrears: boolean | undefined;
  inGrace: boolean | undefined;
  currentBillPlan?: CurrentPayPlan | undefined;
  isAutopayRequired: boolean | undefined;
  campaignCode: string | undefined;
  members: MSSMembers[] | undefined;
  benefitLevels: MSSBenefitLevel | undefined;
  products: MSSProduct[] | undefined;
  enrollments: MSSEnrollment[] | undefined;
  membershipNumber: string | undefined;
  loggedInMember: MSSMembers | undefined;
  hasPaymentInTransit: boolean;
  monthlyPastDue?: number;
  paymentInTransitDetails?: PaymentInTransactionDetail[];
  pendingProducts: {
    productType: MembershipProductType | MembershipLevel;
    effectiveDate: string;
    waitingPeriod: string;
  }[];
  prospectiveMemberRules: {
    upgradesAllowed: boolean;
    downgradesAllowed: boolean;
    allowedGenders: GenderCode[];
    allowedMembershipLevels: MembershipLevel[];
    allowedBillPlans: CurrentPayPlan[];
    autopayDiscountAllowed: boolean;
    memberRoles: {
      roleType: RoleType;
      maximumAge: number;
      minimumAge: number;
      maximumAllowed: number;
      isBirthDateRequired: boolean;
    }[];
    memberProducts: {
      productType: MembershipProductType;
      productRules: { membershipLevel: MembershipLevel; rule: MSSProductStatus }[];
    }[];
  };
  memberCosts?: ICalculateCostResponse;
}

export interface IPriceCart {
  items: PriceCartItem[] | undefined;
  savings: number | undefined;
  salesTax: number | undefined;
  total: number | undefined;
}

export interface IFormData {
  requestedBillPlan: CurrentPayPlan | undefined;
  requestedMembershipLevel: MembershipLevel | undefined;
  members: MSSMembers[] | undefined;
  products: MSSProduct[] | undefined;
}

export interface IShortBenefits {
  [MembershipLevel.CLASSIC]: string[];
  [MembershipLevel.PLUS]: string[];
  [MembershipLevel.PREMIER]: string[];
}

export interface IContent {
  greenBoxMessage?: IGreenBoxMessage;
  shortBenefits: IShortBenefits;
  additionalBenefits?: IAdditionalBenefits[];
}

export interface ILoadingState {
  priceCart: boolean;
}

export interface IAdditionalDiscount {
  type: AdditionalDiscountType;
  value: number;
}

export interface IState {
  memberDetails: IMemberDetails;
  paymentInfo: IPaymentInfo;
  notifications: MSSNotification[] | undefined;
  priceCart: IPriceCart;
  prospectiveCosts: MSSProspectiveCosts;
  additionalDiscounts: IAdditionalDiscount[];
  formData: IFormData;
  loading: ILoadingState;
  content: IContent;
  confirmation: IGetConfirmationResponse | undefined;
  tags: object | undefined;
  isMobileApp: boolean | undefined;
}
